// extracted by mini-css-extract-plugin
export var alertCards = "_0-0";
export var card = "_0-1";
export var fade = "_0-2";
export var hidden = "_0-3";
export var progressBar = "_0-4";
export var roundtime = "_0-5";